import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { PartnerRoutingModule } from './partner-routing.module';
import { PartnerDashboardComponent } from './partner-dashboard/partner-dashboard.component';

@NgModule({
  declarations: [PartnerDashboardComponent],
  imports: [SharedModule, PartnerRoutingModule]
})
export class PartnerModule { }
